import {
    Component,
    OnInit, OnDestroy,
    ViewChild,
    ViewEncapsulation, ChangeDetectorRef,
} from '@angular/core';
import { StaticDataService } from '../../../services/static-data.service';
import { SchedulerService } from '../scheduler.service';
import { Globals } from '../../../globals';
import { AppointmentDataModel, AppointmentStyleModel } from '../models/appoitment-model';
import { LocationModel, OperatoryModel } from '../models/operatory-model';
import moment from 'moment';
import { DxSchedulerComponent } from 'devextreme-angular';
import { ApptTypeEnum } from 'src/app/models/enum/appt-type.enum';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditAppointmentDialogComponent } from '../edit-appointment-dialog/edit-appointment-dialog.component';
import { AppointmentDialogDataV2Model } from '../models/edit-appoitment-data-model';
import { DoctorQueryOptionsModel } from '../../../models/doctors/doctor-query-options.model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { DoctorsService } from '../../../services/doctors.service';
import { CaseProcedureConfigurationModel } from '../../../models/caseProcedures/case-procedure-configuration.model';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { interval, Subscription, firstValueFrom } from 'rxjs';
import { ApptStatusEnum } from '../../../models/enum/appt-status.enum';
import { formatDate } from '@angular/common';
import { PatientCheckinDialogComponent } from '../../../dialog/patient-checkin-dialog/patient-checkin-dialog.component';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { MessagingService } from '../../../services/messaging.service';
import { TdoSharedService } from '../../tdo-shared/tdo-shared.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { WaitListDialogV2Component } from "../wait-list-dialog-v2/wait-list-dialog-v2.component";
import { LabelService } from 'src/app/services/label.service';
import { FormattedLabelEnum } from 'src/app/models/enum/labels/formatted-label.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { UiService } from 'src/app/services/ui.service';
import { loadAppointmentFlags } from '../appointment-flags.util';



@Component({
    standalone: false,
    selector: 'app-tdo-scheduler',
    templateUrl: './tdo-scheduler.component.html',
    styleUrls: ['./tdo-scheduler.component.scss'],
    encapsulation: ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class TdoSchedulerComponent implements OnInit, OnDestroy {
    tdoScheduler: DxSchedulerComponent;
    isPrivateInfoVisible: boolean;
    creatingAppointment: boolean = false;
    get closeWhenOpeningPatient(): boolean { return this.globals.CloseSchedulerWhenOpeningPatient; }
    set closeWhenOpeningPatient(value: boolean) { this.globals.CloseSchedulerWhenOpeningPatient = value; }
    get autoReloadIntervalMinutes(): number { return this.globals.SchedulerAutoReloadIntervalMinutes; }
    set autoReloadIntervalMinutes(value: number) {
        this.globals.SchedulerAutoReloadIntervalMinutes = value;
        this.setupAutoReload();
    }
    autoReloadOptions = [
        { value: 0, label: 'Auto-reload: Off' },
        { value: 1, label: 'Every 1 min' },
        { value: 2, label: 'Every 2 min' },
        { value: 5, label: 'Every 5 min' },
        { value: 10, label: 'Every 10 min' },
        { value: 15, label: 'Every 15 min' },
        { value: 30, label: 'Every 30 min' },
    ];
    private autoReloadSubscription: Subscription;
    currentSelectedCells: any;

    @ViewChild('tdoScheduler', { static: false }) set tdoxScheduler(content: DxSchedulerComponent) {
        if (content) {
            this.tdoScheduler = content;
            this.currentViewDateRange = this.getCurrentViewDateRange();
        }
    }

    visibleStartHour: number = 7;
    visibleEndHour: number = 17;
    schedulerHeight: string = 'auto'; // Let scheduler determine its own height

    calculateSchedulerHeight() {

    }

    selectedViewOption: string = '1';

    emptyCellContent: string = '';

    cellDuration: number = 15;
    viewType: string = 'day';

    currentDateAndTime: Date;
    currentViewDateRange: { startDate: Date, endDate: Date } = null;
    minEndDateAndTime: Date;
    maxStartDateAndTime: Date;
    selectedCellData = {
        StartDate: '',
        EndDate: '',
        Resource_OperatoryId: '',
        enumApptTypeId: '',
        enumApptStatusId: '',
        CaseProcedureId: '',
        isBlockTime: false
    };
    selectedOperatory: any;
    isAppointmentClick: boolean = false;

    viewTypeButtonCaption: string = 'Current View: ' + 'Standard View';

    isCellContextMenuVisible = false;
    isAppContextMenuVisible = false;
    rightClickAppointmentOptions = [
        { ctxId: 1, text: 'Edit Appointment' },
        { ctxId: 2, text: 'Cancel Appointment' },
        { ctxId: 4, text: 'Open Patient' },
        { ctxId: 5, text: 'Check In' }
    ];

    rightClickScheduleOptions = [{ ctxId: 1, text: '.' }];
    todayDate: moment.Moment = moment();

    isTodayAppointment: boolean = false;
    isAppointmentOpen: boolean = false;
    schCurrentTDOCID: number = 13;
    schCurrentLOCID: number = 13;
    schCurrentFromDate: string = '2024-08-5';
    schCurrentToDate: string = '2024-08-5';
    tdoCurrentDate: Date = new Date(2024, 7, 5);  // 2024-8-3

    appointmentsInRange: AppointmentDataModel[] = [];  // contains list of appoitments for TDOCID  for date range

    appointmentsInRangeToShow: AppointmentDataModel[] = [];  // filterd list from appotmentsInRange : locatoions, operatories

    practiceOperatories: OperatoryModel[] = [];
    practiceOperatoriesShow: OperatoryModel[] = [];
    practiceOperatoriesShowFilter: OperatoryModel[] = [];
    practiceOperatoriesShowFilterIDs: any[] = [];

    praticeLocations: LocationModel[] = [];
    selectedLocations: LocationModel[] = [];
    selectedLocationsIDs: any[] = [];
    workDayHourStyles: AppointmentStyleModel[] = [];
    businessHours: any[] = [];
    previousLocationIDs: number[] = [];
    // Cache for cell styles to improve performance

    //private lastWorkDayHourStylesLength = 0;
    //private lastTdoCurrentDate: string = '';
    //private cacheHits = 0;

    protected readonly ApptTypeEnum = ApptTypeEnum;

    currentAppointment: AppointmentDialogDataV2Model;

    allDoctorsList: DoctorDataModel[] = [];

    procedures: CaseProcedureConfigurationModel[] = [];
    TDOUserID: string; // = this.localStorageService.currentUserData.authdata.userid;
    isReschedule: boolean = false;

    // Left-click drag selection properties
    isLeftClickDragging: boolean = false;
    dragStartCell: any = null;
    dragCurrentCell: any = null;
    dragSelectedCells: any[] = [];
    dragStartY: number = 0;
    dragCurrentY: number = 0;
    dragStartTime: Date = null;
    dragEndTime: Date = null;
    dragOperatoryId: string = null;
    lastClickedCellData: any = null; // Store accurate cell data from onCellClick
    pendingDragStart: any = null; // Store pending drag start info from mousedown
    isClearing: boolean = false; // Flag to prevent re-highlighting during clear
    PatientString: string = 'Patient:';

    DEFAULT_CELL_BG_COLOR = '#70F5F5';
    DEFAULT_CELL_COLOR = '#000000';
    DEFAULT_ERROR_CELL_BG_COLOR = '#ffff00';
    DEFAULT_ERROR_CELL_COLOR = '#0000ff';



    constructor(
        private readonly dataService: SchedulerService,
        public globals: Globals,
        public dialog: MatDialog,
        private readonly doctorsService: DoctorsService,
        private readonly cd: ChangeDetectorRef,
        private readonly staticDataService: StaticDataService,
        private readonly authenticationService: AuthenticationService,
        private readonly messagingService: MessagingService,
        private readonly tdoShared: TdoSharedService,
        private readonly localStorageService: LocalStorageService,
        private readonly labelService: LabelService,
        private readonly dialogService: DialogService,
        private readonly uiService: UiService
    ) {



        const today = new Date();

        const startDate = moment(today).subtract(1, 'week').format('YYYY-MM-DD');
        const endDate = moment(today).add(1, 'year').format('YYYY-MM-DD');


        this.dataService.getAppointmentStylesMultiLocation(startDate, endDate).subscribe(res => {
            this.workDayHourStyles = res;
            this.cd.detectChanges();
        });
    }

    onViewControlsCreated(e) {
    }

    goToPreviousDay() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(1, 'days').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    goToNextDay() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(1, 'days').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    goToPreviousMonth() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(1, 'months').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    goToNextMonth() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(1, 'months').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    goToPreviousWeek() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(7, 'days').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    goToNextWeek() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(7, 'days').toDate();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }


    goToToday() {
        this.tdoCurrentDate = new Date();

        this.currentViewDateRange = this.getCurrentViewDateRange();
    }
    gettdoDate() {
        return this.tdoCurrentDate;

    }
    onDateChange(e) {
        this.tdoCurrentDate = e.value;
        this.currentViewDateRange = this.getCurrentViewDateRange();
    }

    async getAppointmentLabels(appointment: AppointmentDataModel, labelType: FormattedLabelEnum) {
        if (appointment.PatientId === null)
            return '';
        const labelsRes = await firstValueFrom(this.labelService.getLabelTokensByFormattedLabel(
            labelType,
            appointment.PatientId,
            appointment.PatientCaseId, null,
            appointment.AppointmentId,
        ));
        let labelText = '';
        let currentLine = '';
        if (labelsRes) {
            for (let label of labelsRes.filter(l => (l.value ?? '').length > 0)) {
                currentLine += `${label.Prefix} ${label.value} ${label.Sufix}`;
                if (label.isEndOfLine) {
                    labelText += `<div class="appt-label-line">${currentLine}</div>`;
                    currentLine = '';
                }
            }
            if (currentLine.length > 0) {
                labelText += `<div class="appt-label-line">${currentLine}</div>`;
            }
        }
        return labelText;
    }

    ngOnInit() {
        this.TDOUserID = this.localStorageService.currentUserData.authdata.userid;
        this.tdoCurrentDate = new Date();
        this.schCurrentTDOCID = parseInt(this.globals.TDOCID);
        this.schCurrentLOCID = parseInt(this.globals.LOCID);

        // Calculate scheduler height accounting for taskbar
        this.calculateSchedulerHeight();

        // Add window resize listener to recalculate height
        this.windowResizeListener = () => {
            this.calculateSchedulerHeight();
        };
        window.addEventListener('resize', this.windowResizeListener);

        // Add document click listener to clear highlights when clicking outside
        this.setupDocumentClickListener();

        // Setup privacy monitoring to detect changes automatically
        this.setupPrivacyMonitoring();

        // Setup auto-reload timer based on persisted user selection
        this.setupAutoReload();

        this.authenticationService.currentUser.subscribe(u => {
        });

        this.selectedLocationsIDs = [];
        this.dataService.getLocations(this.globals.TDOCID).subscribe(res => {
            this.praticeLocations = res;
            const storedLastLocations = this.globals.calendarV2SelectedLocations as LocationModel[];
            if (storedLastLocations) {
                storedLastLocations.forEach(a => {
                    this.selectedLocations.push(a);
                    this.selectedLocationsIDs.push(a.LOCID);
                });
                this.previousLocationIDs = [...this.selectedLocationsIDs];
            }
            else {
                const a = this.praticeLocations.find(f => f.LOCID === this.schCurrentLOCID);
                this.selectedLocations.push(a);
                this.selectedLocationsIDs.push(a.LOCID);
                this.previousLocationIDs = [...this.selectedLocationsIDs];
            }
            this.dataService.getOperatories(this.globals.TDOCID).subscribe(res => {
                this.practiceOperatories = res;
                this.practiceOperatoriesShow = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID))
                .sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);
                this.practiceOperatoriesShowFilter = [];
                const storedLastOps = this.globals.calendarV2SelectedOperatories as any[];
                if (storedLastOps) {
                    storedLastOps.forEach(a => {
                        this.practiceOperatoriesShowFilterIDs.push(a);
                        let z = this.practiceOperatoriesShow.find(f => f.OperatoryId == a);
                        this.practiceOperatoriesShowFilter.push(z);

                    });

                }
                else {
                    this.practiceOperatoriesShowFilter = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID))
                    .sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);

                }
                this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);
                if (this.selectedViewOption === '1' || this.selectedViewOption === '2') {
                    this.schCurrentFromDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
                    this.schCurrentToDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
                }
            });

            this.loadBusinessHours();

        });



        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isIncludeTdo = true;
        doctorQueryModel.isIncludeReferring = true;   // zoli  was false
        this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
            this.allDoctorsList = allDoctors;
        });

        this.dataService.getProcedureGroup('AA000001-0000-0000-0000-000000000001').subscribe((res: CaseProcedureConfigurationModel[]) => {
            // appointment procedures only
            this.procedures = res;
        });

        this.tdoShared.getUserParams(this.TDOUserID, 'tdo-calendar-view').subscribe(res => {
            this.selectedViewOption = res.ParameterValue;
            this.btnViewTypeClicked(null, this.selectedViewOption);
        }, error => {
            console.error('Error', error);
        });
    }


    private loadBusinessHours() {
        const locations = this.selectedLocations.map(l => l.LOCID);
        this.dataService.getBusinessHours(this.globals.TDOCID, locations).subscribe(res => {
            this.businessHours = res;
            const minHour = res.sort((a, b) => ('' + a.VisibleStartTime).localeCompare(b.VisibleStartTime))[0].VisibleStartTime;
            const maxHour = res.sort((a, b) => ('' + b.VisibleEndTime).localeCompare(a.VisibleEndTime))[0].VisibleEndTime;
            const minIncrement = res.sort((a, b) => ('' + a.SchedulerTimeIncrement).localeCompare(b.SchedulerTimeIncrement))[0].SchedulerTimeIncrement;

            this.visibleStartHour = parseInt(minHour.substring(0, 2));
            // Calculate endHour with 15min intervals: if end time falls on round hour, use it; otherwise round up
            const endHour = parseInt(maxHour.substring(0, 2));
            const endMinute = parseInt(maxHour.substring(3, 5));

            if (endMinute === 0) {
                // End time is on round hour (e.g., 20:00) - use exact hour
                this.visibleEndHour = endHour;
            } else {
                // End time has minutes (e.g., 20:30) - round up to next hour
                this.visibleEndHour = endHour + 1;
            }
            this.cellDuration = minIncrement;
            this.cd.detectChanges();
        });
    }

    getCurrentViewDateRange(): { startDate: Date, endDate: Date } {
        if (!this.tdoScheduler) {
            return null;
        }
        const startDate = this.tdoScheduler.instance.getStartViewDate();
        if (!startDate || startDate === undefined || startDate === null) {
            return null;
        }
        let endDate: Date;

        // Calculate end date based on current view type
        switch (this.viewType) {
            case 'day':
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 1);
                break;

            case 'week':
            case 'workWeek':
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 7);
                break;

            case 'month':
                endDate = new Date(startDate);
                endDate.setMonth(startDate.getMonth() + 1);
                break;

            default:
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 1);
        }
        return {
            startDate: startDate,
            endDate: endDate
        };
    }



    getCellClass(dataCell: any): any {
        try {

            const cellDate: Date = dataCell.startDate;
            const cellDateStr = cellDate.toISOString().split('T')[0];
            this.emptyCellContent = '';

            // Default style
            let result = { 'background-color': this.DEFAULT_CELL_BG_COLOR, 'color': this.DEFAULT_CELL_COLOR, 'border': '' };
            // If no current view date range is set, return default style
            if (this.currentViewDateRange === null) {
                return result;
            }

            // Check if cell date is within the current view date range
            // Only apply styles to cells that are in the visible date range
            if (cellDate < this.currentViewDateRange.startDate || cellDate >= this.currentViewDateRange.endDate) {
                return result;
            }

            // Only process styles if we have any
            if (this.workDayHourStyles.length === 0) {
                return result;
            }

            const cellOp = this.practiceOperatoriesShow.find(f => f.OperatoryId == dataCell.groups?.OperatoryId);
            const cellLocationStyles = this.workDayHourStyles.filter(f => f.LOCID == cellOp?.LOCID);
            if (cellLocationStyles.length === 0) {
                return result;
            }
            if (this.businessHours.length > 0) {
                const businessHour = this.businessHours.find(f => f.LOCID == cellOp?.LOCID);
                if (businessHour) {
                    //Default Location Styles
                    result = { 'background-color': businessHour.NonWorkingHours_BackColor, 'color': businessHour.NonWorkingHours_ForeColor, 'border': '' };
                }
            }

            const dayTime = new Date(1900, 0, 1, cellDate.getHours(), cellDate.getMinutes());
            const dayOfWeek = cellDate.getDay();

            // Check for working hours 

            const workingHourStyle = cellLocationStyles.find(f =>
                f.wType === 3 &&
                f.DOW === dayOfWeek &&
                new Date(f.StartTime) <= dayTime &&
                new Date(f.EndTime) > dayTime
                //&& (f.OperatoryID == dataCell.groups?.OperatoryId || !dataCell.groups?.OperatoryId)
            );

            if (workingHourStyle) {
                try {
                    result = JSON.parse(workingHourStyle.TDOcolor);                    

                } catch (e) {
                    console.error('error parsing workingHourStyle', e);
                }
            }

            // blocked hours
            if (dataCell.groups && dataCell.groups.OperatoryId) {
                const workingHourBlockStyle = cellLocationStyles.find(f =>
                    f.wType === 2 &&
                    f.DOW === dayOfWeek &&
                    f.OperatoryID === dataCell.groups.OperatoryId &&
                    new Date(f.StartTime) <= dayTime &&
                    new Date(f.EndTime) > dayTime
                );
                if (workingHourBlockStyle?.TDOcolor) {
                    try {
                        result = JSON.parse(workingHourBlockStyle.TDOcolor);
                        this.emptyCellContent = workingHourBlockStyle.Reason ?? '';
                    } catch (e) {
                        // If parsing fails, use default
                        console.error('error parsing workingHourBlockStyle', e);
                    }
                }
            }

            // non working days

            const nonWorkingDayStyle = cellLocationStyles.find(f =>
                f.wType === 1 &&
                f.NonWorkingDay.toString().split('T')[0] == cellDateStr
            );
            if (nonWorkingDayStyle) {
                try {
                    result = JSON.parse(nonWorkingDayStyle.TDOcolor);

                } catch (e) {
                    // If parsing fails, use default
                    console.error('error parsing nonWorkingDayStyle', e);
                }
            }
            return result;
        }
        catch (e) {
            console.error('getCellClass error', e);
            return { "background-color": this.DEFAULT_ERROR_CELL_BG_COLOR, "color": this.DEFAULT_ERROR_CELL_COLOR };
        }
    }



    //    added: boolean = false;
    onContentReadyTDOScheduler(e) {
        // Ensure the scheduler shows the full time range (using scrollTo - scrollToTime is deprecated)
        if (e.component && this.visibleStartHour != null && this.visibleEndHour != null) {
            const baseDate = this.tdoCurrentDate ? new Date(this.tdoCurrentDate) : new Date();
            setTimeout(() => {
                const startDate = new Date(baseDate);
                startDate.setHours(this.visibleStartHour, 0, 0, 0);
                e.component.scrollTo(startDate);
                this.cd.detectChanges();
                setTimeout(() => {
                    const endDate = new Date(baseDate);
                    endDate.setHours(this.visibleEndHour, 0, 0, 0);
                    e.component.scrollTo(endDate);
                    this.cd.detectChanges();
                }, 50);
            }, 200);
        }
    }

    // maybe useful
    waitFor(variable, callback) {
        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
        var interval = setInterval(function () {
            if (window[variable]) {
                clearInterval(interval);
                callback();
            }
        }, 200);
    }



    onOptionChanged(e) {

        if (e.name === 'currentDate') {
            this.tdoCurrentDate = e.value;
            if (this.tdoCurrentDate.getFullYear() < 1900) {
                return;
            }

            // Update current view date range when date changes
            this.currentViewDateRange = this.getCurrentViewDateRange();

            // Clear cache when date changes

            this.btnViewTypeClicked(null, this.selectedViewOption);
        }

        if (e.name === 'currentView') {
            // Update current view date range when view changes
            this.currentViewDateRange = this.getCurrentViewDateRange();
            // Clear cache when view changes

        }
        if (e.name === "selectedCellData" && e.value.length > 0) {
            const selectedCells = [...e.value];
        }
    }


    btnViewTypeClicked(event, e) {
        this.selectedViewOption = e;

        this.tdoShared.saveUserParams(this.TDOUserID, 'tdo-calendar-view', this.selectedViewOption).subscribe(res => {


        }, error => {
            console.error('error', error);
        });

        if (event !== null) {
            this.viewTypeButtonCaption = 'Current View: ' + (event.target as HTMLButtonElement).textContent;
        }
        else {
            if (this.selectedViewOption == '1') {
                this.viewTypeButtonCaption = 'Current View: Standard View';
            } else if (this.selectedViewOption == '2') {
                this.viewTypeButtonCaption = 'Current View: Day Detail View';
            } else if (this.selectedViewOption == '3') {
                this.viewTypeButtonCaption = 'Current View: Week View';
            } else if (this.selectedViewOption == '4') {
                this.viewTypeButtonCaption = 'Current View: Work Week View';
            } else if (this.selectedViewOption == '5') {
                this.viewTypeButtonCaption = 'Current View: Month View';
            }

        }


        // One Day and Day Detail views are both considered 'day' view type in the scheduler, we just change the date range to show more or less hours
        if (this.selectedViewOption === '1' || this.selectedViewOption === '2') {
            this.schCurrentFromDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
            this.loadAppointments();
            this.viewType = 'day';
            // Update current view date range after view type change
            this.currentViewDateRange = this.getCurrentViewDateRange();
        }
        // For week view, we calculate the Monday of the current week as the start date and Sunday as the end date to show the full week
        else if (e === '3') {

            const prevMonday = new Date(this.tdoCurrentDate);
            prevMonday.setDate(this.tdoCurrentDate.getDate() - (this.tdoCurrentDate.getDay() + 6) % 7);

            const nextSunday = new Date(this.tdoCurrentDate);
            nextSunday.setDate(this.tdoCurrentDate.getDate() + (7 - this.tdoCurrentDate.getDay()));

            this.schCurrentFromDate = moment(prevMonday).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(nextSunday).format('YYYY-MM-DD');

            this.loadAppointments();
            this.viewType = 'week';
            // Update current view date range after view type change
            this.currentViewDateRange = this.getCurrentViewDateRange();
        }
        // For work week view, we use the same date range as week view (Monday to Sunday) but the scheduler will only show Monday to Friday based on the viewType setting
        else if (e === '4') {
            const prevMonday = new Date(this.tdoCurrentDate);
            prevMonday.setDate(this.tdoCurrentDate.getDate() - (this.tdoCurrentDate.getDay() + 6) % 7);

            const nextSunday = new Date(this.tdoCurrentDate);
            nextSunday.setDate(this.tdoCurrentDate.getDate() + (7 - this.tdoCurrentDate.getDay()));

            this.schCurrentFromDate = moment(prevMonday).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(nextSunday).format('YYYY-MM-DD');

            this.loadAppointments();

            this.viewType = 'workWeek';
            // Update current view date range after view type change
            this.currentViewDateRange = this.getCurrentViewDateRange();
        }
        else if (e === '5') {

            const firstOfMonth = new Date(this.tdoCurrentDate.getFullYear(), this.tdoCurrentDate.getMonth(), 1);
            const lastOfMonth = new Date(this.tdoCurrentDate.getFullYear(), this.tdoCurrentDate.getMonth() + 1, 0);

            this.schCurrentFromDate = moment(firstOfMonth).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(lastOfMonth).format('YYYY-MM-DD');

            this.loadAppointments();

            this.viewType = 'month';
            // Update current view date range after view type change
            this.currentViewDateRange = this.getCurrentViewDateRange();
        }
        this.cd.detectChanges();

    }



    removeLOCTag(d) {
        const i = this.selectedLocationsIDs.findIndex(f => f === d.LOCID);
        this.selectedLocationsIDs.splice(i, 1);
        this.onLocationClose(d);
    }

    removeOpTag(d) {

        let i = this.practiceOperatoriesShowFilterIDs.findIndex(f => f === d.OperatoryId);

        let lf = this.practiceOperatoriesShowFilter;
        this.practiceOperatoriesShowFilter = [];

        lf.splice(i, 1);

        this.practiceOperatoriesShowFilter = [...lf];
        this.practiceOperatoriesShowFilterIDs = [];
        this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);

        this.practiceOperatoriesShowFilter.forEach(f => {
            this.practiceOperatoriesShowFilterIDs.push(f.OperatoryId);
        });

        
        this.globals.calendarV2SelectedOperatories = this.practiceOperatoriesShowFilterIDs;
    }

    onLocationClose(event:any) {
        if (this.selectedLocationsIDs.length === 0) {
            return;
        }
        this.selectedLocations = [];
        this.selectedLocationsIDs.forEach(a => {
            const b = new LocationModel();
            b.LOCID = a;
            this.selectedLocations.push(b);
        });

        const newLocations = this.selectedLocationsIDs.filter(f => !this.previousLocationIDs.includes(f));
        const removedLocations = this.previousLocationIDs.filter(f => !this.selectedLocationsIDs.includes(f));
        this.previousLocationIDs = this.selectedLocationsIDs.slice();

        if (newLocations.length > 0) {
            const newOperatories = this.practiceOperatories.filter(f => newLocations.includes(f.LOCID))
            .sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);
            this.practiceOperatoriesShow = this.practiceOperatoriesShow.concat(newOperatories);
            this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.concat(newOperatories);
            this.loadBusinessHours();
        }
        if (removedLocations.length > 0) {
            this.practiceOperatoriesShow = this.practiceOperatoriesShow.filter(f => !removedLocations.includes(f.LOCID));
            this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.filter(f => !removedLocations.includes(f.LOCID));
        }

        
        //this.practiceOperatoriesShow = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);
        //this.practiceOperatoriesShowFilter = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);
        this.appointmentsInRangeToShow = this.appointmentsInRange.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID));

        this.globals.calendarV2SelectedLocations = this.selectedLocations;

        this.practiceOperatoriesShowFilterIDs = [];
        // console.log('onLocationClose practiceOperatoriesShowFilter', this.practiceOperatoriesShowFilter);
        this.practiceOperatoriesShowFilter.forEach(f => {
            this.practiceOperatoriesShowFilterIDs.push(f.OperatoryId);
        });
    }

    onpracticeOperatoriesFilterChange(event: any) {
        this.practiceOperatoriesShowFilter = [];
        this.practiceOperatoriesShowFilterIDs.forEach(a => {

            let z = this.practiceOperatoriesShow.find(f => f.OperatoryId == a);
            this.practiceOperatoriesShowFilter.push(z);

        });
        this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);

        this.practiceOperatoriesShowFilterIDs = [];
        this.practiceOperatoriesShowFilter.forEach(x => {
            this.practiceOperatoriesShowFilterIDs.push(x.OperatoryId);
        });

        this.globals.calendarV2SelectedOperatories = this.practiceOperatoriesShowFilterIDs;
    }




    setupAutoReload() {
        if (this.autoReloadSubscription) {
            this.autoReloadSubscription.unsubscribe();
            this.autoReloadSubscription = null;
        }
        const minutes = this.autoReloadIntervalMinutes;
        if (!minutes || minutes <= 0) {
            return;
        }
        this.autoReloadSubscription = interval(minutes * 60 * 1000).subscribe(() => {
            const scroll = this.captureSchedulerScroll();
            this.loadAppointments();
            if (scroll) {
                this.restoreSchedulerScroll(scroll.top, scroll.left);
            }
        });
    }

    private getSchedulerScrollEl(): HTMLElement | null {
        const inst: any = this.tdoScheduler?.instance;
        const root: HTMLElement | null = (typeof inst?.element === 'function' ? inst.element() : null)
            ?? document.querySelector('dx-scheduler');
        if (!root) return null;
        return (root.querySelector('.dx-scheduler-date-table-scrollable .dx-scrollable-container') as HTMLElement)
            ?? (root.querySelector('.dx-scrollable-container') as HTMLElement);
    }

    private captureSchedulerScroll(): { top: number, left: number } | null {
        const el = this.getSchedulerScrollEl();
        return el ? { top: el.scrollTop, left: el.scrollLeft } : null;
    }

    private restoreSchedulerScroll(top: number, left: number) {
        let attempts = 0;
        const tick = () => {
            const el = this.getSchedulerScrollEl();
            if (el) {
                el.scrollTop = top;
                el.scrollLeft = left;
            }
            if (attempts++ < 8) {
                setTimeout(tick, 150);
            }
        };
        setTimeout(tick, 50);
    }

    loadAppointments() {
        this.dataService.getAppointments(this.globals.TDOCID, this.schCurrentFromDate, this.schCurrentToDate).subscribe(async ares => {
            this.appointmentsInRangeToShow = [];

            this.appointmentsInRange = ares;

            // Do the synchronous prep up-front so appointments can render immediately,
            // then fetch the labels asynchronously and let them fill in as the responses
            // come back (instead of blocking the whole render until every label resolves).
            this.appointmentsInRange.forEach(a => {
                a.parsedEndDate = new Date(a.endDate);
                a.parsedStartDate = new Date(a.startDate);
                a.AppointmentFlagsEnums = this.loadAppointmentsFlags(a.ApptFlags, a.isFirstVisit);
                console.log('a.ApptFlags', a.ApptFlags);
                console.log('a.isFirstVisit', a.isFirstVisit);
                console.log('a.AppointmentFlagsEnums', a.AppointmentFlagsEnums);
                a.PatientFlagsEnums = this.loadPatientFlags(a.PatientFlags);
            });

            this.practiceOperatoriesShow = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID))
            .sort((a, b) => a.LOCID - b.LOCID || a.OperatoryOrder - b.OperatoryOrder);
            this.appointmentsInRangeToShow = this.appointmentsInRange.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID));

            // Render now; labels are populated as each request resolves.
            this.cd.detectChanges();

            let cdScheduled = false;
            const scheduleCd = () => {
                if (cdScheduled) return;
                cdScheduled = true;
                setTimeout(() => { cdScheduled = false; this.cd.detectChanges(); });
            };

            this.appointmentsInRangeToShow.forEach(a => {
                (async () => {
                    try {
                        const [labelLine1, labelTooltip] = await Promise.all([
                            this.getAppointmentLabels(a, FormattedLabelEnum.AppointmentDetails),
                            this.getAppointmentLabels(a, FormattedLabelEnum.AppointmentTooltip)
                        ]);
                        a.LabelLine1 = labelLine1 === '' ? 'No Label setup' : labelLine1;
                        a.LabelTooltip = labelTooltip === '' ? 'No Tooltip setup' : labelTooltip;
                    } catch (e) {
                        console.error('Failed to load appointment labels', e);
                    } finally {
                        scheduleCd();
                    }
                })();
            });

            this.cd.detectChanges();
        });

    }

    /**
     * Returns the appropriate tooltip content based on privacy settings
     * @param appointment The appointment data
     * @returns The tooltip content (masked if privacy enabled)
     */
    getAppointmentTooltip(appointment: AppointmentDataModel): string {
        if (appointment.isBlockTime) {
            return appointment.Description ?? 'Blocked Time';
        }
        else if (this.globals.PrivacyEnabled) {
            return '*******';
        }
        else
            return appointment.LabelTooltip ?? 'loading info...';
    }

    /**
     * Returns the appropriate label content based on privacy settings
     * @param appointment The appointment data
     * @returns The label content (masked if privacy enabled)
     */
    getAppointmentLabel(appointment: AppointmentDataModel): string {
        if (this.globals.PrivacyEnabled) {
            return this.displayPatientNameMasked(appointment.PatientName ?? 'loading info...');
        }
        return appointment.LabelLine1 ?? 'loading info...';
    }

    /**
     * Displays patient name with masked last name when privacy is enabled
     * @param patientName - The full patient name
     * @returns Masked patient name (e.g., "Moises J****")
     */
    displayPatientNameMasked(patientName: string): string {
        if (!this.globals.PrivacyEnabled) {
            return patientName;
        }
        if (!patientName || patientName.trim() === '') {
            return this.PatientString + ' *******';
        }

        // Split the name into parts
        const nameParts = patientName.trim().split(' ').filter(part => part.length > 0);

        if (nameParts.length === 0) {
            return this.PatientString + ' *******';
        }

        if (nameParts.length === 1) {
            // Only one name part, mask it
            const maskedName = nameParts[0].charAt(0) + '*'.repeat(nameParts[0].length - 1);
            return `${this.PatientString} ${maskedName}`;
        }

        // Get first name and last name
        const firstName = nameParts[0];
        const lastName = nameParts[nameParts.length - 1];

        if (lastName.length <= 1) {
            // Last name is too short to mask meaningfully
            return `${this.PatientString} ${firstName} ${lastName}`;
        }

        // Mask the last name
        const maskedLastName = lastName.charAt(0) + '*'.repeat(lastName.length - 1);

        // If there are middle names, include them
        if (nameParts.length > 2) {
            const middleNames = nameParts.slice(1, -1).join(' ');
            return `${this.PatientString} ${firstName} ${middleNames} ${maskedLastName}`;
        }

        return `${this.PatientString} ${firstName} ${maskedLastName}`;
    }

    loadAppointmentsFlags(flags, isFirstVisit: boolean = false) {
        // parse the flags string into an array of AppointmentFlagDataModel and add the
        // "First Appointment" flag (TX-6530) when the appointment is the patient's first visit
        return loadAppointmentFlags(flags, isFirstVisit);
    }

    loadPatientFlags(flags: string) {
        if (flags) {
            const flagsObject = JSON.parse(flags);
            return flagsObject.pflag;
        }
        return [];
    }


    showAppoitmentData(appt) {
        return 'APPT';
    }

    onAppointmentUpdated(app) {
        // on drag updates:
        // - drag whole appotment: parsedStartDate, parsedEndDate
        // - change duration drag: parsedStartDate, parsedEndDate
        // - change operatory: OperatoryId
        if (app.appointmentData.isBlockTime) {
            return;
        }
        app.appointmentData.startDate = this.formatDateTime(app.appointmentData.parsedStartDate);
        app.appointmentData.endDate = this.formatDateTime(app.appointmentData.parsedEndDate);


        // update
        this.dataService.updateAppoitment(app.appointmentData).subscribe(res => {

        });


    }



    formatDate2YYYY_MM_DD(date) {
        // returns YYYY-MM-DD
        // tslint:disable-next-line:one-variable-per-declaration prefer-const
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        // tslint:disable-next-line:prefer-const
        const year = d.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }

    onAppointmentContext(e: any) {
        if (e.appointmentData.isBlockTime) {
            this.isAppContextMenuVisible = false;
            e.cancel = true; // prevent default context menu         
            e.event.cancel = true;
            e.event.preventDefault();
            this.rightClickAppointmentOptions = [];
            return; 
        }
        else {
            this.currentAppointment = new AppointmentDialogDataV2Model();
            this.currentAppointment.currentLocationId = this.globals.LOCID;
            this.currentAppointment.timeIncrement = 30;    // from config
            this.currentAppointment.procedures = this.procedures;
            this.currentAppointment.isReadOnly = false;
            this.currentAppointment.appointment = e.appointmentData;
            this.currentAppointment.allDoctors = this.allDoctorsList;
            this.currentAppointment.appointment.dataAppoitmentDetails = [];
            this.currentAppointment.cancellingAppointment = false;
            this.currentAppointment.confirmingAppointment = false;
            this.currentAppointment.operatories = this.practiceOperatories;
            this.isAppointmentClick = true;

            if (this.formatDate2YYYY_MM_DD(new Date(this.currentAppointment.appointment.startDate).toDateString()) === this.formatDate2YYYY_MM_DD(this.todayDate.format())) {
                this.isTodayAppointment = true;
            }
            if (this.currentAppointment.appointment.isReservation) {
                this.rightClickAppointmentOptions = [];
                if (this.authenticationService.currentUserValue.authdata.userid === this.currentAppointment.appointment.xauditCreatedBy) {
                    this.rightClickAppointmentOptions.push({ ctxId: 7, text: 'Remove Reserved Time Slot' });
                }
            }
            else
                if (this.currentAppointment.appointment.enumApptTypeId == ApptTypeEnum.BlockIn || this.currentAppointment.appointment.enumApptTypeId == ApptTypeEnum.BlockOut) {

                    this.rightClickAppointmentOptions = [];
                    if (this.authenticationService.currentUserValue.authdata.userid === this.currentAppointment.appointment.xauditCreatedBy) {
                        this.rightClickAppointmentOptions.push({ ctxId: 7, text: 'Remove Block' });  // same as reservation
                    }
                }
                else if ((this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Remote_Checked_In ||
                    this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Checked_in ||
                    this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Seated ||
                    this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.ReadyToCheckOut) && this.isTodayAppointment) {
                    this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit Appointment' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 9, text: 'Delete Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 6, text: 'Check Out' }];
                }
                else if (this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Checked_out) {
                    this.rightClickAppointmentOptions = [{ ctxId: 4, text: 'Open Patient' }];
                }
                else if (this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Canceled) {
                    this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit Appointment' }, { ctxId: 4, text: 'Open Patient' }];
                }
                else if (this.isTodayAppointment) {
                    this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit Appointment' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 9, text: 'Delete Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 5, text: 'Check In' }];
                    if (this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Confirmed) { this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
                }
                else if ((this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Remote_Checked_In &&
                    this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Checked_in &&
                    this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Seated && this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Checked_out)) {
                    this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit Appointment' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 9, text: 'Delete Appointment' }, { ctxId: 4, text: 'Open Patient' }];
                    if (this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Confirmed) { this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
                }
        }
    }

    onAppContextMenuShowing(e: any) {
        if (this.currentAppointment?.appointment?.isBlockTime) {
            e.cancel = true;
        }
    }

    ctxMenuItemClickApp(e) {
        if (this.currentAppointment?.appointment?.isBlockTime) {
            this.isAppContextMenuVisible = false;
            return;
        }

        this.isAppContextMenuVisible = false;
        switch (e.itemData.ctxId) {
            case 1:
                // edit
                this.currentAppointment.cancellingAppointment = false;
                this.currentAppointment.confirmingAppointment = false;
                this.showCustomPopup('edit');
                break;
            case 2:
                // cancel
                this.currentAppointment.confirmingAppointment = false;
                this.currentAppointment.cancellingAppointment = true;
                this.showCustomPopup('edit');

                /// / CHANGE TO DIALOG CANCEL END

                break;
            case 3:
                // Reschedule
                // var enumStatusReschedule: string = '00000072-0000-0000-0000-000000000007';
                // onAppointmentFormOpening(e, true, '');
                break;
            case 4: // Open patient
                this.changeToPatientAndGotoCaseView(this.currentAppointment.appointment);

                if (this.closeWhenOpeningPatient && window.opener) {
                    try { window.opener.focus(); } catch { /* cross-origin opener access may throw */ }
                    window.close();
                }

                break;
            case 5: // Check in

                const config = new MatDialogConfig();
                config.panelClass = 'dialog';
                config.data = this.currentAppointment.appointment; //  this.selectedAppt;
                this.dialog.open(PatientCheckinDialogComponent, config).afterClosed().subscribe((res) => {
                    if (res) {
                        const appointmentSearchDateRange = this.formatDate2YYYY_MM_DD(this.tdoCurrentDate) + ' ' + this.formatDate2YYYY_MM_DD(this.tdoCurrentDate);
                        this.loadAppointments();

                    }
                });
                break;
            case 6:  // Check out
                localStorage.setItem('selectedAppt', JSON.stringify(this.currentAppointment.appointment));
                let patientName = '';

                patientName = this.currentAppointment.appointment?.PatientName;

                this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
                    PatientID: this.currentAppointment.appointment?.PatientId,
                    PatientName: patientName,
                    Process: MessagingConstants.CHECKOUT_PATIENT_START,
                    PatientCaseId: this.currentAppointment.appointment.PatientCaseId
                });

                break;
            case 7:  // delete if reserved slot
                this.dataService.deleteAppointment(this.currentAppointment.appointment.AppointmentId).subscribe((res) => {
                    this.loadAppointments();
                });

                break;
            case 8:  // Confirm
                this.currentAppointment.cancellingAppointment = false;
                this.currentAppointment.confirmingAppointment = true;

                this.showCustomPopup('edit');

                break;
            case 9:  // Delete appointment -> confirm only, then behave like a cancellation (moves to Cancellations operatory)
                this.dialogService.openConfirmDialog('Are you sure you want to delete this appointment?', false, true, 'Delete Appointment')
                    .subscribe((result) => {
                        if (result === true) {
                            const appt = this.currentAppointment.appointment;
                            appt.enumApptStatusId = ApptStatusEnum.Canceled;
                            appt.isReservation = false;
                            this.dataService.updateAppoitment(appt).subscribe(() => {
                                this.loadAppointments();
                            });
                        }
                    });

                break;



            default:
            // code block
        }


    }

    changeToPatientAndGotoCaseView(appointmentData: AppointmentDataModel) {


        if (!this.isBlockAppt(appointmentData)) {


            const patientName = appointmentData.PatientName;

            this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
                PatientID: appointmentData.PatientId,
                PatientName: patientName,
                Process: MessagingConstants.RELOAD_SCHEDULE_APPOINTMENTS,
                clearCurrentQuery: false
            });
        }
    }

    ctxMenuItemClickCell(e) {
        switch (e.itemData.ctxId) {

            case 9: // reschedule
                if (this.globals.RescheduleAppointmentRequest) {
                    // move apptment to current selected date time
                    if (!this.currentAppointment) {
                        this.uiService.displayMessage('Warning','Please select the time slot to reschedule');
                        return;
                    }

                    let appointment = {
                        AppointmentId: this.globals.RescheduleAppointmentRequest.AppointmentId,
                        note: this.globals.RescheduleAppointmentRequest.Reschedule_Note,
                        newStartDate: this.currentAppointment.appointment.startDate,
                        newOperatoryId: this.currentAppointment.appointment.OperatoryId,
                        LOCID: this.currentAppointment.appointment.LOCID
                    };
                    this.dataService.rescheduleAppoitment(appointment).subscribe(res => {
                        this.globals.RescheduleAppointmentRequest = null;                        
                        this.loadAppointments();
                    });




                }
            default:

        }
    }

    onMouseDown(event: MouseEvent) {


        // Reset appointment click flag at the start of any mouse down
        this.isAppointmentClick = false;

        // Handle left-click drag start
        if (event.button === 0) { // Left mouse button


            // Check if we're clicking on a scheduler cell
            const cellElement = event.target as HTMLElement;
            const schedulerCell = cellElement.closest('.dx-scheduler-date-table-cell');

            if (schedulerCell) {
                // Start drag immediately - DevExtreme will handle the cell selection
                this.isLeftClickDragging = true;
                this.dragStartCell = { element: schedulerCell, cellData: null };
                this.dragCurrentCell = this.dragStartCell;
                this.dragStartY = event.clientY;
                this.dragCurrentY = event.clientY;
                this.dragSelectedCells = [];

                // Initial values - will be updated by selectedCellDataChange
                this.dragStartTime = null;
                this.dragEndTime = null;
                this.dragOperatoryId = null;


                // Add initial highlighting to the clicked cell
                (schedulerCell as HTMLElement).style.setProperty('background-color', 'rgba(0, 123, 255, 0.3)', 'important');
                (schedulerCell as HTMLElement).style.setProperty('border', '2px solid #007bff', 'important');
                (schedulerCell as HTMLElement).classList.add('drag-selected');
                this.cd.detectChanges();
            } 
        }
    }

    onMouseMove(event: MouseEvent) {
        if (this.isLeftClickDragging && event.buttons === 1) { // Left button held down
            // Update current Y position - DevExtreme will handle the rest
            this.dragCurrentY = event.clientY;
            // DevExtreme's selectedCellDataChange will fire and update our highlighting
        }
    }

    onMouseUp(event: MouseEvent) {


        // Handle left-click drag end
        if (event.button === 0 && this.isLeftClickDragging) {

            event.preventDefault();

            // Create visual highlight for the selected area (green)
            this.highlightDraggedArea();

            // After drag selection, proceed with existing appointment creation functionality
            this.createAppointmentFromDragSelection();

            // Reset drag state
            this.resetDragState();

            // Schedule highlight clear as backup
            this.scheduleHighlightClear();
            return;
        }

        // Handle regular click (not after drag)
        if (event.button === 0) {
            event.preventDefault();
            const cellElement = event.target as HTMLElement;
            const schedulerCell = cellElement.closest('.dx-scheduler-date-table-cell');

            if (schedulerCell && !this.isLeftClickDragging) {

                // Create appointment from regular click (non-drag)
                this.createAppointmentFromClick();
            } else if (!schedulerCell) {

                // Clicked outside scheduler cells, clear any existing highlights
                this.clearAllHighlights();
            }
        }
    }

    private createAppointmentFromDragSelection() {
        if (this.creatingAppointment) {
            return;
        }
        // Use DevExtreme's selectedCellData for accurate time information
        if (!this.tdoScheduler || !this.tdoScheduler.selectedCellData || this.tdoScheduler.selectedCellData.length === 0) {
            console.warn('No selected cell data available from scheduler');
            return;
        }

        this.creatingAppointment = true;
        // Get the selected cells from DevExtreme scheduler
        const selectedCells = this.tdoScheduler.selectedCellData;

        // new appoitment
        this.currentAppointment = new AppointmentDialogDataV2Model();
        this.currentAppointment.currentLocationId = this.globals.LOCID;
        this.currentAppointment.timeIncrement = 30;    // from config
        this.currentAppointment.procedures = this.procedures;
        this.currentAppointment.isReadOnly = false;
        this.currentAppointment.appointment = null;
        this.currentAppointment.allDoctors = this.allDoctorsList;
        this.currentAppointment.cancellingAppointment = false;
        this.currentAppointment.confirmingAppointment = false;
        this.currentAppointment.operatories = this.practiceOperatories;

        // Create appointment using DevExtreme's accurate cell data
        const appt = new AppointmentDataModel();
        appt.LOCID = parseInt(this.globals.LOCID);

        // Get operatory from the last selected cell (same as original logic)
        const lastCellIndex = selectedCells.length - 1;
        appt.OperatoryId = selectedCells[lastCellIndex].groups.OperatoryId;
        const apptOperatory = this.practiceOperatories.find(o => o.OperatoryId.toLowerCase() === appt.OperatoryId.toLowerCase());
        if (apptOperatory && apptOperatory.LOCID !== appt.LOCID) {
            appt.LOCID = apptOperatory.LOCID;
        }
        
        appt.isReservation = false;

        // Use the first cell's start time and calculated end time for accurate range
        appt.startDate = this.formatDateTime(selectedCells[0].startDate);

        // Use our calculated end time which accounts for DevExtreme over-selection
        if (selectedCells.length > 1) {
            // Multi-cell selection: use end time of second-to-last cell to match visual selection
            const secondToLastCell = selectedCells[selectedCells.length - 2];
            appt.endDate = this.formatDateTime(secondToLastCell.endDate);
        } else {
            // Single cell selection: use end time of the cell
            appt.endDate = this.formatDateTime(selectedCells[lastCellIndex].endDate);
        }


        appt.enumApptTypeId = this.ApptTypeEnum.Scheduled;
        appt.enumApptStatusId = ApptStatusEnum.Unconfirmed;
        appt.CaseProcedureId = '';
        appt.AppointmentId = undefined;
        appt.dataAppoitmentDetails = [];

        this.currentAppointment.appointment = appt;
        this.currentAppointment.appointment.isReservation = true;



        if (!this.globals.RescheduleAppointmentRequest) {
            this.dataService.saveNewAppoitment(this.currentAppointment.appointment).subscribe(res => {
                this.currentAppointment.appointment.Reservation_AppointmentId = res.AppointmentId;
                this.showCustomPopup('new');
            });
        } else {
            if (this.globals.RescheduleAppointmentRequest) {
                this.rightClickScheduleOptions = null;
                this.rightClickScheduleOptions = [{ ctxId: 9, text: 'Reschedule Here' }];
                this.creatingAppointment = false;
                return;
            }
        }
    }

    private createAppointmentFromClick() {
        if (this.creatingAppointment) {
            return;
        }
        this.creatingAppointment = true;
        // Original click-based appointment creation logic
        this.currentAppointment = new AppointmentDialogDataV2Model();
        this.currentAppointment.currentLocationId = this.globals.LOCID;
        this.currentAppointment.timeIncrement = 30;    // from config
        this.currentAppointment.procedures = this.procedures;
        this.currentAppointment.isReadOnly = false;
        this.currentAppointment.appointment = null;
        this.currentAppointment.allDoctors = this.allDoctorsList;
        this.currentAppointment.cancellingAppointment = false;
        this.currentAppointment.confirmingAppointment = false;
        this.currentAppointment.operatories = this.practiceOperatories;

        // new appoitment
        const appt = new AppointmentDataModel();
        appt.LOCID = parseInt(this.globals.LOCID);
        const imax = this.tdoScheduler.selectedCellData.length - 1;
        appt.OperatoryId = this.tdoScheduler.selectedCellData[imax].groups.OperatoryId;
        const apptOperatory = this.practiceOperatories.find(o => o.OperatoryId.toLowerCase() === appt.OperatoryId.toLowerCase());
        if (apptOperatory && apptOperatory.LOCID !== appt.LOCID) {
            appt.LOCID = apptOperatory.LOCID;
        }
        appt.isReservation = false;
        appt.startDate = this.formatDateTime(this.tdoScheduler.selectedCellData[0].startDate);
        appt.endDate = this.formatDateTime(this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1].endDate);

        appt.enumApptTypeId = this.ApptTypeEnum.Scheduled;
        appt.enumApptStatusId = ApptStatusEnum.Unconfirmed;
        appt.CaseProcedureId = '';
        appt.AppointmentId = undefined;
        appt.dataAppoitmentDetails = [];

        this.currentAppointment.appointment = appt;
        this.currentAppointment.appointment.isReservation = true;

        if (!this.globals.RescheduleAppointmentRequest) {
            this.dataService.saveNewAppoitment(this.currentAppointment.appointment).subscribe(res => {
                this.currentAppointment.appointment.Reservation_AppointmentId = res.AppointmentId;
                this.showCustomPopup('new');
            });
        } else {
            if (this.globals.RescheduleAppointmentRequest) {
                this.rightClickScheduleOptions = null;
                this.rightClickScheduleOptions = [{ ctxId: 9, text: 'Reschedule Here' }];
                return;
            }
        }
    }

    formatDateTime(date) {
        let ret: string = '';

        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }

        ret = year + '-' + month + '-' + day;


        let h: string = '' + d.getHours();
        let m: string = '' + d.getMinutes();
        if (h.length < 2) { h = '0' + h; }
        if (m.length < 2) { m = '0' + m; }

        ret = ret + ' ' + h + ':' + m;
        return ret;
    }


    onCellClick(e: any) {
        e.cancel = true;
        this.isAppointmentClick = false;
        // Store the accurate cell data from DevExtreme
        this.lastClickedCellData = e.cellData;
        // If we have a pending drag start, now we can actually start the drag with accurate data
        if (this.pendingDragStart) {

            this.isLeftClickDragging = true;
            this.dragStartCell = { element: this.pendingDragStart.element, cellData: this.lastClickedCellData };
            this.dragCurrentCell = this.dragStartCell;
            this.dragStartY = this.pendingDragStart.startY;
            this.dragCurrentY = this.pendingDragStart.startY;
            this.dragSelectedCells = [this.dragStartCell];

            // Store start time and operatory using accurate cell data
            this.dragStartTime = this.lastClickedCellData.startDate;
            this.dragEndTime = this.lastClickedCellData.endDate;
            this.dragOperatoryId = this.lastClickedCellData.groups ? this.lastClickedCellData.groups.OperatoryId : null;


            // Add visual feedback for the starting cell
            const schedulerCell = this.pendingDragStart.element;
            (schedulerCell as HTMLElement).style.setProperty('background-color', 'rgba(0, 123, 255, 0.3)', 'important');
            (schedulerCell as HTMLElement).style.setProperty('border', '2px solid #007bff', 'important');
            (schedulerCell as HTMLElement).classList.add('drag-selected');
            this.cd.detectChanges();

            // Clear the pending drag start
            this.pendingDragStart = null;
        }
    }
    onAppointmentClick(e: any) {
        if (e.appointmentData.isBlockTime) {
            return;
        }
        this.isAppointmentClick = true;

        this.currentAppointment = new AppointmentDialogDataV2Model();
        this.currentAppointment.currentLocationId = this.globals.LOCID;
        this.currentAppointment.timeIncrement = 30;    // from config
        this.currentAppointment.procedures = this.procedures;
        this.currentAppointment.isReadOnly = false;
        this.currentAppointment.appointment = e.appointmentData;
        this.currentAppointment.allDoctors = this.allDoctorsList;
        this.currentAppointment.appointment.dataAppoitmentDetails = [];
        this.currentAppointment.cancellingAppointment = false;
        this.currentAppointment.confirmingAppointment = false;
        this.currentAppointment.operatories = this.practiceOperatories;


    }

    onOpenMedicalInformationFormDialog(appointmentData: AppointmentDataModel) {
        // ApptMedicalInformation
        this.dialogService.openMedicalHistory(appointmentData.PatientId);
    }


    isBlockAppt(appt: AppointmentDataModel) {
        return appt.enumApptTypeId == this.ApptTypeEnum.BlockIn || appt.enumApptTypeId == this.ApptTypeEnum.BlockOut;
    }

    // on double click on appoitment
    overrideDefaultPopup(event:any) {
        if (event.appointmentData) {
            event.cancel = true; // prevent default context menu            
            if (event.appointmentData.isBlockTime) {
                event.cancel = true; // prevent default context menu
            }
            else {
                let appt = event.appointmentData as AppointmentDataModel;
                if (appt.parentAppointmentId) {
                    appt = this.appointmentsInRange.find(p => p.AppointmentId.toLowerCase() === appt.parentAppointmentId.toLowerCase());
                }
                this.showCustomPopup('edit');
            }
        }
    }

    setCurrentDateAndTime() {
        const now = new Date();
        const currentHours = now.getHours();
        let currentMinutes = now.getMinutes();

        if (currentMinutes === 0) {
            // do nothing
        } else if (currentMinutes < 15) {
            currentMinutes = 0;
        } else if (currentMinutes < 30) {
            currentMinutes = 15;
        } else if (currentMinutes < 45) {
            currentMinutes = 30;
        } else {
            currentMinutes = 45;
        }

        this.currentDateAndTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHours, currentMinutes);
        this.maxStartDateAndTime = new Date(this.selectedCellData.EndDate);
        this.minEndDateAndTime = new Date(this.selectedCellData.StartDate);
    }

    // async showCustomPopup(appointment: AppointmentDataModel, action: string = 'edit') {
    async showCustomPopup(action: string = 'edit') {
        const config = new MatDialogConfig();
        config.width = '70%';
        config.height = '80%';
        config.disableClose = true;
        config.data = this.currentAppointment;

        config.panelClass = 'dialog-appointment-edit';
        // config.height = '96vh';
        config.autoFocus = false;
        this.dialog.open(EditAppointmentDialogComponent, config).afterClosed().subscribe(
            res => {
                this.creatingAppointment = false;
                if (res === 'reschedule') {
                    this.isReschedule = true;
                    this.cd.detectChanges();
                } else if (res) {
                    this.loadAppointments();
                }
            }
        );
    }
    onClickClearReschedule() {
        this.globals.RescheduleAppointmentRequest = null;
    }
    onSelectedCellDataChange(selectedCellData: any) {

        // Don't process selection changes if we're in the middle of clearing
        if (this.isClearing) {

            return;
        }

        // If we're in the middle of a drag operation, update our drag selection with accurate data
        if (this.isLeftClickDragging && selectedCellData && selectedCellData.length > 0) {

            // Update our drag times with accurate data from DevExtreme
            this.dragStartTime = selectedCellData[0].startDate;
            // Fix end time calculation: DevExtreme often includes one extra cell beyond visual selection
            // If user selects 8am-10am, DevExtreme might include 10am-10:15am cell
            // Use the start time of the last cell as the end time to match visual selection
            const lastCellIndex = selectedCellData.length - 1;
            const lastCell = selectedCellData[lastCellIndex];
            //this.dragEndTime = lastCell.endDate;
            //Disable "second to last cell" selection, highlight all cells within the mouse drag    
            // For multi-cell selection, the end time should be the END of the second-to-last cell
            // This accounts for DevExtreme including one extra cell beyond visual selection
            if (selectedCellData.length > 1) {
                // Use the end time of the second-to-last cell to match visual selection
                const secondToLastCell = selectedCellData[selectedCellData.length - 2];
                this.dragEndTime = secondToLastCell.endDate;
            } else {
                // Single cell selection - use the end time
                this.dragEndTime = lastCell.endDate;
            }

            this.dragOperatoryId = selectedCellData[0].groups ? selectedCellData[0].groups.OperatoryId : null;




            // Apply highlighting to the selected cells
            this.highlightSelectedCells(selectedCellData);
        }
        else if (!this.isLeftClickDragging && (!selectedCellData || selectedCellData.length === 0)) {

            // If not dragging and no cells selected, clear highlights
            this.clearDragHighlights();
        }
    }

    highlightSelectedCells(selectedCellData: any[]) {
        // Clear previous highlights
        this.clearDragHighlights();

        // Find and highlight all cells that match the selected time slots
        const schedulerElement = document.querySelector('.dx-scheduler-date-table');
        if (schedulerElement) {
            const cells = schedulerElement.querySelectorAll('.dx-scheduler-date-table-cell');

            cells.forEach(cellElement => {
                // Check if this cell corresponds to any of the selected cell data
                //const rect = (cellElement as HTMLElement).getBoundingClientRect();

                // Simple approach: highlight cells in the same operatory column within the time range
                if (this.isCellInSelection(cellElement as HTMLElement, selectedCellData)) {
                    (cellElement as HTMLElement).style.setProperty('background-color', 'rgba(0, 123, 255, 0.3)', 'important');
                    (cellElement as HTMLElement).style.setProperty('border', '2px solid #007bff', 'important');
                    (cellElement as HTMLElement).classList.add('drag-selected');
                    //this.cd.detectChanges();
                }
            });
        }
    }

    isCellInSelection(cellElement: HTMLElement, selectedCellData: any[]): boolean {
        // Simple approach: check if cell is within the Y range of our drag
        const rect = cellElement.getBoundingClientRect();
        const cellCenterY = rect.top + (rect.height / 3);

        const startY = Math.min(this.dragStartY, this.dragCurrentY);
        const endY = Math.max(this.dragStartY, this.dragCurrentY);

        // Check if cell is in the Y range
        if (cellCenterY >= startY && cellCenterY <= endY) {
            // Check if it's in the same column as the start cell
            if (this.dragStartCell?.element) {
                const startCellRect = (this.dragStartCell.element as HTMLElement).getBoundingClientRect();
                const cellLeft = rect.left;
                const startCellLeft = startCellRect.left;

                return Math.abs(cellLeft - startCellLeft) < 50;
            }
        }

        return false;
    }

    onOpenWaitListComponent() {
        const config = new MatDialogConfig();
        config.width = '800px';
        config.height = '800px';
        config.panelClass = 'dialog';
        //config.data = this.appointmentDialogData;
        const dialogRef = this.dialog.open(WaitListDialogV2Component, config);
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.isReschedule = true;

                if (this.globals.RescheduleAppointmentRequest) {
                    this.rightClickScheduleOptions = null;
                    this.rightClickScheduleOptions = [{ ctxId: 9, text: 'Reschedule Here' }];
                    return;
                }

            }
        }, err => {
            console.error(err);
        });

    }

    // Helper methods for drag selection
    getCellFromEvent(event: MouseEvent): any {
        const target = event.target as HTMLElement;

        // Find the scheduler cell element - try multiple possible selectors
        let cellElement = target.closest('.dx-scheduler-date-table-cell') ||
            target.closest('.dx-scheduler-work-space-day .dx-scheduler-date-table-cell') ||
            target.closest('[data-dx-scheduler-cell]');

        if (!cellElement) {
            return null;
        }

        try {
            // Try to get cell data from DevExtreme scheduler instance
            if (this.tdoScheduler && this.tdoScheduler.instance) {
                const scheduler = this.tdoScheduler.instance;

                // Get the cell coordinates
                const rect = cellElement.getBoundingClientRect();
                const schedulerRect = scheduler.element().getBoundingClientRect();

                // Calculate relative position
                const relativeX = rect.left - schedulerRect.left;
                const relativeY = rect.top - schedulerRect.top;

                // Try to get cell data using DevExtreme's API
                try {
                    // This is an approximation - DevExtreme might have different methods
                    const cellData = (scheduler as any).getCellDataByCoordinates?.(relativeX, relativeY);
                    if (cellData) {
                        return {
                            element: cellElement,
                            cellData: cellData
                        };
                    }
                } catch (e) {
                    // Fallback if getCellDataByCoordinates doesn't exist
                }

                // Fallback: estimate cell data based on position and scheduler settings
                const cellHeight = rect.height;
                const cellWidth = rect.width;

                // Calculate time based on cell position (this is an approximation)
                const minutesPerCell = this.cellDuration;
                const startHour = this.visibleStartHour;

                const cellRow = Math.floor((rect.top - schedulerRect.top) / cellHeight);
                const cellCol = Math.floor((rect.left - schedulerRect.left) / cellWidth);

                const startMinutes = startHour * 60 + (cellRow * minutesPerCell);
                const startDate = new Date(this.tdoCurrentDate);
                startDate.setHours(Math.floor(startMinutes / 60), startMinutes % 60, 0, 0);

                const endDate = new Date(startDate);
                endDate.setMinutes(endDate.getMinutes() + minutesPerCell);

                // Try to determine operatory from column or other attributes
                let operatoryId = 'default';
                if (this.practiceOperatoriesShowFilter && this.practiceOperatoriesShowFilter.length > cellCol) {
                    operatoryId = this.practiceOperatoriesShowFilter[cellCol]?.OperatoryId || 'default';
                }

                return {
                    element: cellElement,
                    cellData: {
                        startDate: startDate,
                        endDate: endDate,
                        groups: { OperatoryId: operatoryId }
                    }
                };
            }

            return null;
        } catch (e) {
            console.error('Error getting cell data:', e);
            return null;
        }
    }

    updateDragSelection() {

        if (!this.dragStartTime || !this.dragEndTime || !this.dragOperatoryId) {
            return;
        }

        // Clear previous selection highlights
        this.clearDragHighlights();

        // Calculate the Y range for highlighting
        const startY = Math.min(this.dragStartY, this.dragCurrentY);
        const endY = Math.max(this.dragStartY, this.dragCurrentY);


        // Find all cells in the same operatory column that are within the Y range
        const schedulerElement = document.querySelector('.dx-scheduler-date-table');
        if (schedulerElement) {
            const cells = schedulerElement.querySelectorAll('.dx-scheduler-date-table-cell');
            let highlightedCount = 0;
            cells.forEach((cellElement, index) => {
                const rect = (cellElement as HTMLElement).getBoundingClientRect();
                const cellCenterY = rect.top + (rect.height / 2);

                // Check if cell is within the drag Y range
                if (cellCenterY >= startY && cellCenterY <= endY) {
                    // Simple operatory check - find the cell's column position
                    const cellLeft = rect.left;

                    if (this.dragStartCell && this.dragStartCell.element) {
                        const startCellRect = (this.dragStartCell.element as HTMLElement).getBoundingClientRect();
                        const startCellLeft = startCellRect.left;

                        // Check if it's in the same column (same operatory) with some tolerance
                        if (Math.abs(cellLeft - startCellLeft) < 50) { // Increased tolerance
                            // Add drag highlighting
                            (cellElement as HTMLElement).style.setProperty('background-color', 'rgba(0, 123, 255, 0.3)', 'important');
                            (cellElement as HTMLElement).style.setProperty('border', '2px solid #007bff', 'important');
                            (cellElement as HTMLElement).classList.add('drag-selected');
                            this.cd.detectChanges();
                            this.dragSelectedCells.push({ element: cellElement });
                            highlightedCount++;

                        } 
                    }
                }
            });
        } else {
            //  console.log('Scheduler element not found');
        }
    }

    getCellsInTimeRange(startTime: Date, endTime: Date, operatoryId: string): any[] {
        const cells = [];

        try {
            // Find all scheduler cells in the DOM
            const schedulerElement = document.querySelector('.dx-scheduler-date-table');
            if (!schedulerElement) {
                return cells;
            }

            const cellElements = schedulerElement.querySelectorAll('.dx-scheduler-date-table-cell');

            cellElements.forEach(cellElement => {
                // Try to get cell data for each element
                const rect = cellElement.getBoundingClientRect();
                const mockEvent = { target: cellElement } as any;
                const cellData = this.getCellFromEvent(mockEvent);

                if (cellData && cellData.cellData) {
                    const cellStartTime = new Date(cellData.cellData.startDate);
                    const cellEndTime = new Date(cellData.cellData.endDate);
                    const cellOperatoryId = cellData.cellData.groups?.OperatoryId;

                    // Check if cell is in the time range and same operatory
                    if (cellOperatoryId === operatoryId &&
                        cellStartTime >= startTime &&
                        cellEndTime <= endTime) {
                        cells.push(cellData);
                    }
                }
            });
        } catch (e) {
            console.error('Error getting cells in time range:', e);
        }

        return cells;
    }

    // highlightCell(cell: any, highlight: boolean) {
    //     if (!cell || !cell.element) {
    //         return;
    //     }

    //     if (highlight) {
    //         cell.element.classList.add('drag-selected');
    //         //cell.element.style.backgroundColor = 'rgba(0, 123, 255, 0.3)';
    //         //cell.element.style.border = '2px solid #007bff';
    //         this.cd.detectChanges();
    //     } else {
    //         cell.element.classList.remove('drag-selected');
    //         //cell.element.style.backgroundColor = '';
    //         //cell.element.style.border = '';
    //         this.cd.detectChanges();
    //     }
    // }

    highlightDraggedArea() {
        // Convert drag-selected cells to permanently-selected
        const dragSelectedCells = document.querySelectorAll('.drag-selected');
        dragSelectedCells.forEach(cell => {
            (cell as HTMLElement).classList.remove('drag-selected');
            (cell as HTMLElement).classList.add('permanently-selected');
            (cell as HTMLElement).style.backgroundColor = 'rgba(40, 167, 69, 0.3)';
            (cell as HTMLElement).style.border = '2px solid #28a745';
        });

        // Optional: Clear the highlight after a few seconds
        setTimeout(() => {
            this.clearPermanentHighlights();
        }, 10000);
    }

    clearDragHighlights() {
        // Reset the dragSelectedCells array
        this.dragSelectedCells = [];

        // Remove drag selection styling from all cells that have the drag-selected class
        const dragSelectedCells = document.querySelectorAll('.drag-selected');
        dragSelectedCells.forEach(cell => {
            (cell as HTMLElement).classList.remove('drag-selected');
            (cell as HTMLElement).style.removeProperty('background-color');
            (cell as HTMLElement).style.removeProperty('border');
        });
    }

    clearPermanentHighlights() {
        const selectedCells = document.querySelectorAll('.permanently-selected');
        selectedCells.forEach(cell => {
            cell.classList.remove('permanently-selected');
            (cell as HTMLElement).style.backgroundColor = '';
            (cell as HTMLElement).style.border = '';
        });
    }

    clearAllHighlights() {


        // Set flag to prevent re-highlighting during clear
        this.isClearing = true;

        // Debug: Find ALL cells with any kind of highlighting
        const allCells = document.querySelectorAll('.dx-scheduler-date-table-cell');
        const highlightedCells = [];

        allCells.forEach((cell, index) => {
            const element = cell as HTMLElement;
            const hasBackgroundColor = element.style.backgroundColor && element.style.backgroundColor !== '';
            const hasBorder = element.style.border && element.style.border !== '';
            const hasClasses = element.classList.contains('drag-selected') || element.classList.contains('permanently-selected');

            if (hasBackgroundColor || hasBorder || hasClasses) {
                highlightedCells.push({
                    index,
                    element,
                    backgroundColor: element.style.backgroundColor,
                    border: element.style.border,
                    classes: element.className
                });
            }
        });
        // FIRST: Clear DevExtreme's internal selection state to prevent re-selection
        if (this.tdoScheduler && this.tdoScheduler.selectedCellData) {

            this.tdoScheduler.selectedCellData = [];
        }

        // Clear ALL highlighted cells found
        highlightedCells.forEach(cell => {
            cell.element.style.removeProperty('background-color');
            cell.element.style.removeProperty('border');
            cell.element.classList.remove('drag-selected', 'permanently-selected');

        });

        // Also use the original clearing methods as backup
        this.clearDragHighlights();
        this.clearPermanentHighlights();

        // Reset drag state
        this.resetDragState();

        // Clear the clearing flag after a short delay to allow DOM updates
        setTimeout(() => {
            this.isClearing = false;

        }, 100);

        // Verify clearing worked
        const remainingHighlighted = [];
        allCells.forEach((cell, index) => {
            const element = cell as HTMLElement;
            const hasBackgroundColor = element.style.backgroundColor && element.style.backgroundColor !== '';
            const hasBorder = element.style.border && element.style.border !== '';
            const hasClasses = element.classList.contains('drag-selected') || element.classList.contains('permanently-selected');

            if (hasBackgroundColor || hasBorder || hasClasses) {
                remainingHighlighted.push({ index, backgroundColor: element.style.backgroundColor, border: element.style.border, classes: element.className });
            }
        });


    }

    // Manual clear method for testing
    manualClearHighlights() {

        this.clearAllHighlights();
    }

    // Alternative approach: Clear highlights after a delay when not dragging
    scheduleHighlightClear() {
        if (!this.isLeftClickDragging) {
            setTimeout(() => {
                if (!this.isLeftClickDragging) {

                    this.clearAllHighlights();
                }
            }, 2000);
        }
    }

    private documentClickListener: (event: Event) => void;
    private windowResizeListener: () => void;
    private privacyMonitorSubscription: Subscription;

    setupPrivacyMonitoring() {
        // Monitor privacy setting changes every 500ms
        this.privacyMonitorSubscription = interval(500).subscribe(() => {
            const currentPrivacySetting = !this.isPrivateInfoVisible;
            const currentGlobalsSetting = this.globals.PrivacyEnabled;
            // If there's a mismatch, update the globals and trigger change detection
            if (currentPrivacySetting !== currentGlobalsSetting) {
                // Update the globals setting
                this.isPrivateInfoVisible = !currentGlobalsSetting;
                // Force change detection to update the UI
                this.cd.detectChanges();
            }
        });
    }

    setupDocumentClickListener() {
        this.documentClickListener = (event: Event) => {
            const target = event.target as HTMLElement;
            // Check if the click is outside the scheduler
            const schedulerContainer = document.querySelector('[data-cy="scheduler-component"]');
            if (schedulerContainer) {
                const isInsideScheduler = schedulerContainer.contains(target);
                if (!isInsideScheduler) {
                    this.clearAllHighlights();
                } 
            } 
        };

        // Add the listener
        document.addEventListener('click', this.documentClickListener);

    }

    ngOnDestroy() {
        // Clean up the document click listener
        if (this.documentClickListener) {
            document.removeEventListener('click', this.documentClickListener);
        }

        // Clean up the window resize listener
        if (this.windowResizeListener) {
            window.removeEventListener('resize', this.windowResizeListener);
        }

        // Clean up privacy monitoring subscription
        if (this.privacyMonitorSubscription) {
            this.privacyMonitorSubscription.unsubscribe();
        }

        // Clean up auto-reload subscription
        if (this.autoReloadSubscription) {
            this.autoReloadSubscription.unsubscribe();
            this.autoReloadSubscription = null;
        }

        // Clear any remaining highlights
        this.clearAllHighlights();
    }

    selectDraggedCellsInScheduler() {
        if (!this.tdoScheduler || !this.dragStartTime || !this.dragEndTime || !this.dragOperatoryId) {
            return;
        }

        try {
            // Calculate the proper start and end times (ensure start <= end)
            const startTime = new Date(Math.min(this.dragStartTime.getTime(), this.dragEndTime.getTime()));
            const endTime = new Date(Math.max(this.dragStartTime.getTime(), this.dragEndTime.getTime()));

            // Create cell data array for the time range
            const cellsToSelect = [];
            const current = new Date(startTime);

            while (current < endTime) {
                const cellEndTime = new Date(current.getTime() + (this.cellDuration * 60000)); // cellDuration in minutes

                cellsToSelect.push({
                    startDate: new Date(current),
                    endDate: cellEndTime,
                    groups: { OperatoryId: this.dragOperatoryId },
                    allDay: false
                });

                current.setTime(current.getTime() + (this.cellDuration * 60000));
            }

            // Set the selected cell data programmatically
            this.tdoScheduler.selectedCellData = cellsToSelect;

        } catch (error) {
            console.error('Error selecting dragged cells:', error);
        }
    }

    resetDragState() {
        this.isLeftClickDragging = false;
        this.dragStartCell = null;
        this.dragCurrentCell = null;
        this.dragSelectedCells = [];
        this.dragStartY = 0;
        this.dragCurrentY = 0;
        this.dragStartTime = null;
        this.dragEndTime = null;
        this.dragOperatoryId = null;
        this.lastClickedCellData = null; // Reset accurate cell data
        this.pendingDragStart = null; // Reset pending drag start
        this.isClearing = false; // Reset clearing flag
        this.isAppointmentClick = false; // Reset appointment click flag

        // Remove temporary drag selection styling
        this.clearDragHighlights();
    }

    onPrivacyClick() {
        this.isPrivateInfoVisible = !this.isPrivateInfoVisible;
        this.globals.PrivacyEnabled = !this.isPrivateInfoVisible;

        // Hide content in 30 minutes
        if (this.isPrivateInfoVisible) {
            setTimeout(() => {
                this.isPrivateInfoVisible = false;
                this.globals.PrivacyEnabled = !this.isPrivateInfoVisible;
            }, 1800000);
        }
    }

    onAppointmentUpdating(event: any) {
        if (event.oldData?.isBlockTime) {
            event.cancel = true;
        }
    } 

}
